const round2 = (x) => Number(Number(x).toFixed(2));

// Acre-weighted mean of rows that have a value. Blank rows stay out of both the total and the acres.
export const averagePresent = (rows, value, weight) => {
  const present = rows.filter((row) => value(row) != null);
  const acres = present.reduce((sum, row) => sum + (Number(weight(row)) || 0), 0);
  if (!acres) return null;
  return round2(
    present.reduce((sum, row) => sum + Number(value(row)) * (Number(weight(row)) || 0), 0) / acres
  );
};
